var _style, _g, _g2, _g3, _g4, _g5, _defs, _g6, _defs2, _g7, _defs3, _g8, _g9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectsImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 400",
    style: {
      enableBackground: "new 0 0 500 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#AADFF0;}\r\n\t.st1{fill:#58857A;}\r\n\t.st2{fill:#76A699;}\r\n\t.st3{fill:#9FC7BD;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#EEE4D9;}\r\n\t.st6{fill:#444244;}\r\n\t.st7{fill:#BEC0C2;}\r\n\t.st8{fill:#9EBFD8;}\r\n\t.st9{fill:#CC882A;}\r\n\t.st10{fill:#D6723A;}\r\n\t.st11{opacity:0.8;}\r\n\t.st12{fill:#514342;}\r\n\t.st13{opacity:0.8;fill:#514342;enable-background:new    ;}\r\n\t.st14{fill:#D1868D;}\r\n\t.st15{opacity:0.3;}\r\n\t.st16{fill:#72787A;}\r\n\t.st17{clip-path:url(#SVGID_2_);}\r\n\t.st18{fill:#9C9FA0;}\r\n\t.st19{fill:#2F3D69;}\r\n\t.st20{fill:#AE584B;}\r\n\t.st21{fill:#D16A4B;}\r\n\t.st22{clip-path:url(#SVGID_4_);}\r\n\t.st23{fill:#84534A;}\r\n\t.st24{clip-path:url(#SVGID_6_);}\r\n\t.st25{fill:#BA3213;}\r\n\t.st26{fill:#FCBDA9;}\r\n\t.st27{opacity:0.5;fill:#D1778E;enable-background:new    ;}\r\n\t.st28{fill:#637690;}\r\n\t.st29{fill:#3B3348;}\r\n\t.st30{opacity:0.5;fill:#3B3348;enable-background:new    ;}\r\n\t.st31{fill:#F99889;}\r\n\t.st32{fill:#008AC5;}\r\n\t.st33{fill:#2E5151;}\r\n\t.st34{opacity:0.5;fill:#2E5151;enable-background:new    ;}\r\n\t.st35{fill:#4D3930;}\r\n\t.st36{fill:#44322B;}\r\n\t.st37{fill:#382823;}\r\n\t.st38{fill:#626B6D;}\r\n\t.st39{fill:#FEAE65;}\r\n\t.st40{fill:#E0DFEA;}\r\n\t.st41{opacity:0.5;fill:#9EBFD8;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1384_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_514_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_855_",
    className: "st0",
    d: "M277.3,38.7c58.5,7.9,72.6,43.2,99.4,48.7c40.1,8.2,82.9,14.5,73.5,64s-33.4,62.1-24.7,104.5 c8.6,42.4,25.9,67.6-4.3,89.9c-30.2,22.4-65.6-2.8-117,7.9c-51.5,10.6-111.6,26.7-206.6-5.1S67.9,268.9,64,231.6 c-3.9-37.3-39.2-50.1-18.7-93.6C90.1,42.7,236.4,33.3,277.3,38.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_513_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.6,363.6c-34.7,0-70-6.2-107.7-18.8c-27-9-43.1-20.1-49.4-33.7c-7.2-15.8-0.2-32.7,6.6-49.1 c5.1-12.4,10-24.1,8.8-35c-1.5-14.1-7.5-24.6-13.3-34.8c-9.4-16.5-18.2-32-5.4-59.3c10.4-22.2,27.2-41.3,49.7-56.8 c18.9-13,41.9-23.5,68.3-31.1c47.5-13.6,94.7-14.6,114.9-11.9c36,4.8,55.3,20,70.9,32.2c9.8,7.7,18.3,14.4,28.5,16.5 c1.8,0.4,3.6,0.7,5.4,1.1c38.3,7.8,77.9,15.8,68.7,63.9c-3.8,20-10,34-15.4,46.3c-8.1,18.3-14.4,32.7-9.3,57.8 c1.9,9.4,4.3,18.1,6.4,25.8c7.5,27.4,12.9,47.2-11.1,65c-17,12.6-35.8,10.4-57.5,7.8c-17.4-2.1-37.1-4.5-59.9,0.2 c-3.2,0.7-6.5,1.3-9.7,2c-24.2,5.1-51.7,10.9-83.7,11.5C217.5,363.6,215.6,363.6,213.6,363.6z M263.7,33.7 c-23.8,0-57.8,3.2-92,13c-40.1,11.5-93,36-116.9,87c-12.5,26.5-4.2,40.9,5.3,57.7c5.9,10.3,12,21,13.5,35.5 c1.2,11.3-3.7,23.2-8.9,35.8c-6.6,16-13.5,32.6-6.6,47.8c6,13.2,21.8,23.9,48.3,32.8c88.9,29.8,146,17.7,196.4,7.1 c3.3-0.7,6.5-1.4,9.7-2c23.1-4.8,42.9-2.4,60.4-0.3c21.4,2.6,39.8,4.8,56.3-7.4c23-17.1,18-35.4,10.4-63.2 c-2.1-7.7-4.5-16.5-6.4-25.9c-5.2-25.6,1.2-40.3,9.4-58.8c5.4-12.3,11.5-26.2,15.3-46c4-21.1-1-35.5-15.9-45.4 c-13.2-8.8-32.7-12.7-51.5-16.5c-1.8-0.4-3.6-0.7-5.4-1.1c-10.6-2.2-19.3-9-29.2-16.8c-15.4-12.1-34.6-27.1-70.1-31.9 C280.4,34.2,272.8,33.7,263.7,33.7z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1159_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1314_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M295.5,234.7l-0.7-0.2c14.5-58.1,28-92,45.2-113.3l0.6,0.5C323.4,142.9,309.9,176.7,295.5,234.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1313_",
    className: "st1",
    d: "M332,132.5c0.8-6,5.8-19.9,12.9-18.9c7.1,1-1,11.1-6.7,15C334.4,131.2,332,132.5,332,132.5z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1312_",
    className: "st1",
    d: "M325.6,143.7c3-5.4,8.8-10.5,16.1-10.7c4.3-0.1,5.8,8.2-4.4,8.2 C329.8,141.1,325.6,143.7,325.6,143.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1311_",
    className: "st1",
    d: "M325.9,143.1c2.9-12.1-0.6-21.1-5.9-20.1c-5.3,1.1-2.2,8.7,1.1,11.7 C324.4,137.7,325.9,143.1,325.9,143.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1310_",
    className: "st1",
    d: "M319.5,156.6c6.5-9.4,14.4-10.5,17.9-8.4c3.5,2.1,2.7,8.9-4.7,7.6 C324.8,154.4,319.5,156.6,319.5,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1309_",
    className: "st1",
    d: "M313.5,171.5c12.7-12.5,23.5-7.4,22.6-3.4c-0.9,4-7.1,2.9-12.3,2.3 C318.6,169.8,313.5,171.5,313.5,171.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1308_",
    className: "st1",
    d: "M308.4,186.7c13.3-13.6,25.4-11,26.4-6c1,5-3,5.9-12.6,3.6 C312.4,181.8,308.4,186.7,308.4,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1307_",
    className: "st1",
    d: "M319.6,156.2c2.5-17.4-8.4-21.9-12.1-17.2s6.6,8,8.7,11.8 C318.2,154.6,319.6,156.2,319.6,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1306_",
    className: "st1",
    d: "M314,170.4c0.3-8.9-4.2-19.9-10.4-19.9s-5.6,6.8-0.8,9.1C309.8,163,314,170.4,314,170.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1305_",
    className: "st1",
    d: "M303.3,204.2c4.9-8.1,20.5-14.1,26.6-8.3c6.1,5.7-3,9.3-10.6,7.2 C311.7,201,303.3,204.2,303.3,204.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1304_",
    className: "st1",
    d: "M297.7,224.2c8.1-13.4,24.9-13.9,31.4-7.3c6.5,6.6-5.2,9-15,5.1 C304.4,218.1,297.7,224.2,297.7,224.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1303_",
    className: "st1",
    d: "M308.7,184.7c-3.2-18.9-14.6-20.5-17.5-15.9C288.3,173.4,308.7,184.7,308.7,184.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1302_",
    className: "st1",
    d: "M302.8,204c1-14.1-10.8-24.4-17-20.4s6.3,8.9,9.7,11.9C298.8,198.4,302.8,204,302.8,204z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1301_",
    className: "st1",
    d: "M297.6,224.2c-3.7-14.5-17.6-29-22.6-22.1c-4.4,6.1,2.7,8.8,14.2,12.4 C295.6,216.5,297.6,224.2,297.6,224.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1300_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.9,237.3l-0.7-0.3c15.6-31.4,28.9-52.6,42-66.9c12.3-13.4,24.9-21.6,41.1-26.5l0.2,0.7 C348.5,154,327.6,177.5,297.9,237.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1299_",
    className: "st2",
    d: "M367.8,148.6c8.8-10.8,18.5-11.4,19.1-6C387.8,150.3,367.8,148.6,367.8,148.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1298_",
    className: "st2",
    d: "M356.9,154.8c14.6-1.3,21.9,2.5,21.6,6.8c-0.3,4.3-4.1,4.5-11.7-0.4 C359.1,156.4,356.9,154.8,356.9,154.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1297_",
    className: "st2",
    d: "M358.2,153.9c5.2-7.6,5.6-18.6-2.2-18.5c-7.8,0.1,1,9.8,1.8,12.8 C358.6,151.1,358.2,153.9,358.2,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1296_",
    className: "st2",
    d: "M343.7,165.9c13.6-6.9,27.8-1.8,25.4,5.9s-9-1.8-14.4-3.6 C349.2,166.4,343.7,165.9,343.7,165.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1295_",
    className: "st2",
    d: "M338.6,144.8c6.7-2.5,13.5,9.9,5.7,20.4c0,0,0.7-6.5-5.8-11.6S335.8,145.8,338.6,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1294_",
    className: "st2",
    d: "M328.1,184.2c7.7-10.6,21.6-9.4,26.4-3.9c4.9,5.5-0.2,9-4.2,8.8c-4-0.2-7.3-4.8-13.3-5.1 C331.1,183.6,328.1,184.2,328.1,184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1293_",
    className: "st2",
    d: "M331.4,179.5c4.3-12.4-0.2-22.3-8.2-20.3c-8.1,2,4.1,8.6,5.9,12.8 C330.9,176.1,331.4,179.5,331.4,179.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1292_",
    className: "st2",
    d: "M317.7,199.6c21-11.6,31-2,28.4,3.6c-2.6,5.7-12.6-1.2-16.6-2.9 C324.4,198.3,317.7,199.6,317.7,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1291_",
    className: "st2",
    d: "M307.3,218.3c28.1-21,47.5,8.8,17.8,1.5C314.9,217.3,307.3,218.3,307.3,218.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1290_",
    className: "st2",
    d: "M310.3,212.7c0.3-13-12.1-25.6-17.5-18.1c-5.4,7.4,11,10.7,13.6,13.9 C309,211.6,310.3,212.7,310.3,212.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1289_",
    className: "st2",
    d: "M317.7,199.6c4-4.5,3.9-23.3-6.2-25.3c-10.1-2-3.9,10.9,0.1,15.5 C315.6,194.4,317.7,199.6,317.7,199.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1183_",
    className: "st2",
    d: "M300.1,232.6c16.1-11.1,26.8,8.2,8.3,0.5C304,231.3,300.1,232.6,300.1,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1182_",
    className: "st2",
    d: "M301.8,228.6c1.8-9.4-5.8-17.8-11-13s9.1,7.9,10.2,10.5 C302.1,228.8,301.8,228.6,301.8,228.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1181_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M293.6,233.7l-0.8-0.1c1.7-19.2-3.7-61.1-35.7-82.1l0.4-0.6C289.9,172.1,295.3,214.3,293.6,233.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1180_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.8,238.5l-0.4-0.6c24-15.2,55.6-10.6,55.9-10.6l-0.1,0.7C368.9,228,337.6,223.5,313.8,238.5z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1179_",
    className: "st1",
    d: "M354.3,227c9.7-4.6,15.6-5.3,19-0.2c3.4,5.1-4.8,5.9-10.3,3.8 C357.5,228.5,354.3,227,354.3,227z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1178_",
    className: "st1",
    d: "M338.3,228.7c15.6,0.9,24.6,8.4,22.4,15.7c-2.3,7.3-8.6-6-12.7-9.8 C344,230.7,338.3,228.7,338.3,228.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1177_",
    className: "st1",
    d: "M324.5,232.6c12,0.4,22.9,10.1,22.9,15.5s-10.3,5.7-15.1-3.1 C327.6,236.1,324.5,232.6,324.5,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1175_",
    className: "st1",
    d: "M339.7,228.5c10.3-3,9.1-13.3,4.7-17.4c-4.4-4.2-8-1.7-6.3,4.2c1.1,3.7,4.7,5.9,3.2,10.1 C340.4,227.6,339.7,228.5,339.7,228.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1173_",
    className: "st1",
    d: "M324.6,232.6c5.9-3.3,9-19.1,0-23.3c-8.2-3.8-10.8,3.5-3.7,10.8 C325.6,225,324.6,232.6,324.6,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1172_",
    className: "st3",
    d: "M264.1,156.5c-2.4-4.5-12.2-14.3-12.9-8.8C250.5,153.2,264.1,156.5,264.1,156.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1171_",
    className: "st3",
    d: "M274.2,166.6c-3.9-4.4-7.8-19,0.5-16.9C282.9,151.8,274.2,166.6,274.2,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1170_",
    className: "st3",
    d: "M274.2,166.6c-10.2-3.6-21.5-7.1-19.7-0.3S274.2,166.6,274.2,166.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1169_",
    className: "st3",
    d: "M282.1,178.9c-2.1-13,5.1-21,11-16.6C299,166.6,282.1,178.9,282.1,178.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1168_",
    className: "st3",
    d: "M284.3,183.6c-5.9-5.5-19.9-12-22.2-4.6C259.8,186.3,284.3,183.6,284.3,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1167_",
    className: "st3",
    d: "M287.8,192.7c5.2-12.5,10.8-19.5,15.4-15.1C307.9,182,287.8,192.7,287.8,192.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1166_",
    className: "st3",
    d: "M288.3,194.6c-8.7-4.9-23.7-9.7-24.1-2.4S288.3,194.6,288.3,194.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1165_",
    className: "st3",
    d: "M291.9,207.8c1.9-12,13.6-20.7,17-13.6C312.2,201.3,291.9,207.8,291.9,207.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1164_",
    className: "st3",
    d: "M291.7,209c-10.7-4.1-28.1-10.9-26.5-1.9C266.7,216.2,291.7,209,291.7,209z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1163_",
    className: "st3",
    d: "M293,216.6c4-6.7,19.2-12.1,21.6-4.2C317,220.3,293,216.6,293,216.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1162_",
    className: "st3",
    d: "M293.2,223.4c-1.5-2.8-18-12.1-19.9-5.6C271.5,224.4,293.2,223.4,293.2,223.4z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1161_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1360_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M205.2,251.9c-5.8-59.5-14.1-94.9-28-118.4l0.7-0.4c13.9,23.6,22.3,59.2,28.1,118.7L205.2,251.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1359_",
    className: "st1",
    d: "M184,145.5c0.1-6.1-2.8-20.5-10-20.6s-0.7,11.1,4.5,15.8C181.9,143.8,184,145.5,184,145.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1358_",
    className: "st1",
    d: "M188.7,157.4c-2.1-5.8-7.1-11.6-14.3-12.9c-4.2-0.8-6.9,7.3,3.1,8.7 C184.9,154.3,188.7,157.4,188.7,157.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1357_",
    className: "st1",
    d: "M188.5,156.9c-1-12.4,3.7-20.8,8.8-19s0.9,9-2.8,11.4C190.8,151.7,188.5,156.9,188.5,156.9z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1356_",
    className: "st1",
    d: "M192.9,171.1c-5.1-10.2-12.7-12.5-16.5-10.9s-4,8.4,3.5,8.2 C187.9,168.2,192.9,171.1,192.9,171.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1355_",
    className: "st1",
    d: "M196.5,186.7c-10.7-14.2-22.2-10.8-21.9-6.7c0.3,4.1,6.6,3.9,11.9,4 C191.8,184.3,196.5,186.7,196.5,186.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1354_",
    className: "st1",
    d: "M199.4,202.5c-11.2-15.4-23.5-14.6-25.2-9.9c-1.7,4.8,2.1,6.3,12,5.4 C196.1,197.1,199.4,202.5,199.4,202.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1353_",
    className: "st1",
    d: "M192.8,170.8c0.1-17.6,11.5-20.5,14.5-15.2c3,5.2-7.7,6.9-10.3,10.4 C194.4,169.3,192.8,170.8,192.8,170.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1352_",
    className: "st1",
    d: "M196.3,185.6c1-8.9,7-19.1,13.2-18.2s4.5,7.5-0.5,9.1C201.5,178.9,196.3,185.6,196.3,185.6z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1351_",
    className: "st1",
    d: "M201.9,220.6c-3.7-8.7-18.2-16.9-25.1-12.1s1.6,9.6,9.4,8.7 C194.1,216.2,201.9,220.6,201.9,220.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1350_",
    className: "st1",
    d: "M204.5,241.2c-6.1-14.4-22.6-17.4-30-11.8c-7.4,5.6,3.8,9.7,14.1,7.2 C198.8,234.2,204.5,241.2,204.5,241.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1349_",
    className: "st1",
    d: "M199.4,200.5c5.9-18.2,17.5-18.1,19.6-13.1C221.2,192.3,199.4,200.5,199.4,200.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1348_",
    className: "st1",
    d: "M202.5,220.4c1.1-14.1,14.3-22.5,19.8-17.7c5.5,4.8-7.5,7.9-11.3,10.3 C207.2,215.5,202.5,220.4,202.5,220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1347_",
    className: "st1",
    d: "M204.6,241.2c5.7-13.8,21.6-26.1,25.6-18.5c3.5,6.7-3.9,8.3-15.9,10.2 C207.7,233.9,204.6,241.2,204.6,241.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1346_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202.4,254.1c-20.7-63.5-37.9-89.8-68.2-104.1l0.3-0.7c15.3,7.2,26.7,17.2,36.8,32.3 c10.8,16.1,20.9,39,31.7,72.3L202.4,254.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1345_",
    className: "st2",
    d: "M146.3,156.2c-7.1-12-16.6-14-18-8.7C126.2,154.8,146.3,156.2,146.3,156.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1344_",
    className: "st2",
    d: "M156.1,163.8c-14.2-3.4-22-0.8-22.4,3.6c-0.4,4.3,3.4,5,11.6,1.4S156.1,163.8,156.1,163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1343_",
    className: "st2",
    d: "M155,162.8c-4-8.3-2.8-19.2,4.9-18s-2.4,9.6-3.7,12.4C154.9,159.9,155,162.8,155,162.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1342_",
    className: "st2",
    d: "M167.6,176.8c-12.4-8.8-27.2-5.9-26,2.1c1.3,8,9.2-0.4,14.8-1.4 C162,176.5,167.6,176.8,167.6,176.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1341_",
    className: "st2",
    d: "M175.6,156.6c-6.3-3.4-14.8,7.8-8.6,19.3c0,0,0.2-6.6,7.4-10.7 C181.6,161.2,178.3,158,175.6,156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1340_",
    className: "st2",
    d: "M180.3,197.2c-6.1-11.6-19.9-12.5-25.6-7.8s-1.1,8.9,2.9,9.3c4,0.4,8-3.7,13.9-3.1 C177.4,196.2,180.3,197.2,180.3,197.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1339_",
    className: "st2",
    d: "M177.8,192c-2.5-12.9,3.4-22,11.1-18.9c7.7,3.1-5.3,7.9-7.7,11.8 C178.7,188.8,177.8,192,177.8,192z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1338_",
    className: "st2",
    d: "M188.3,213.9c-19.1-14.5-30.3-6.6-28.6-0.6c1.7,6,12.6,0.6,16.8-0.4 C181.9,211.6,188.3,213.9,188.3,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1337_",
    className: "st2",
    d: "M195.9,234c-24.7-24.8-48.3,1.7-17.8-1.2C188.5,231.8,195.9,234,195.9,234z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1336_",
    className: "st2",
    d: "M193.7,228c1.6-12.9,15.7-23.5,19.9-15.4s-12.4,9-15.4,11.7 C195.2,227.1,193.7,228,193.7,228z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1335_",
    className: "st2",
    d: "M188.3,213.9c-3.2-5.1-0.4-23.6,9.9-24.1c10.3-0.5,2.3,11.4-2.4,15.4 C191.2,209.1,188.3,213.9,188.3,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1334_",
    className: "st2",
    d: "M200.9,249.2c-14.3-13.4-27.7,4.2-8.3-0.7C197.3,247.3,200.9,249.2,200.9,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1333_",
    className: "st2",
    d: "M199.8,244.9c-0.4-9.5,8.3-16.8,12.8-11.2c4.4,5.6-10.2,6.5-11.6,8.9 C199.5,245.1,199.8,244.9,199.8,244.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1332_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M207.9,251.2l-0.8,0c1.2-19.4,12.7-60.4,47.8-76.6l0.3,0.7C220.5,191.3,209.1,232,207.9,251.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1331_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M200,254.4c-21.2-18.3-52.7-18.5-53.3-18.5c0,0,0-0.8,0-0.8c0.3,0,32.2,0.1,53.8,18.6L200,254.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1330_",
    className: "st1",
    d: "M161.6,237.1c-8.9-6-14.6-7.5-18.8-2.9c-4.1,4.6,3.9,6.5,9.6,5.2 C158.2,238.1,161.6,237.1,161.6,237.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1329_",
    className: "st1",
    d: "M177.2,241.1c-15.5-1.4-25.6,4.7-24.4,12.2c1.2,7.5,9.4-4.7,14-7.9 C171.3,242.2,177.2,241.1,177.2,241.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1328_",
    className: "st1",
    d: "M190.3,247c-12-1.4-24.1,6.6-24.9,12s9.4,7.2,15.4-0.9C186.7,250,190.3,247,190.3,247z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1327_",
    className: "st1",
    d: "M175.9,240.7c-9.8-4.5-7.1-14.5-2.1-17.9c5-3.5,8.2-0.5,5.6,5.1c-1.6,3.5-5.5,5.2-4.6,9.5 C175.3,239.8,175.9,240.7,175.9,240.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1326_",
    className: "st1",
    d: "M190.1,247c-5.3-4.2-6.1-20.2,3.4-23c8.7-2.6,10.2,5,2,11.3 C190.3,239.3,190.1,247,190.1,247z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1325_",
    className: "st3",
    d: "M247.7,179.1c3-4.1,14.2-12.3,14.1-6.8C261.6,177.9,247.7,179.1,247.7,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1324_",
    className: "st3",
    d: "M236.2,187.6c4.5-3.8,10.5-17.6,2-16.8S236.2,187.6,236.2,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1323_",
    className: "st3",
    d: "M236.2,187.6c10.6-2,22.3-3.9,19.5,2.6C252.9,196.7,236.2,187.6,236.2,187.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1322_",
    className: "st3",
    d: "M226.6,198.7c3.9-12.6-2-21.5-8.4-18.1C211.7,184,226.6,198.7,226.6,198.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1321_",
    className: "st3",
    d: "M223.8,203c6.7-4.6,21.4-9,22.6-1.3C247.6,209.2,223.8,203,223.8,203z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1320_",
    className: "st3",
    d: "M218.9,211.5c-3.3-13.1-7.8-20.9-13-17.2C200.6,197.9,218.9,211.5,218.9,211.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1319_",
    className: "st3",
    d: "M218.1,213.3c9.3-3.6,24.9-6.1,24.2,1.1C241.7,221.7,218.1,213.3,218.1,213.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1318_",
    className: "st3",
    d: "M212.7,225.8c-0.1-12.2-10.5-22.5-14.8-16C193.5,216.4,212.7,225.8,212.7,225.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1317_",
    className: "st3",
    d: "M212.7,227.1c11.1-2.5,29.4-6.7,26.5,2S212.7,227.1,212.7,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1316_",
    className: "st3",
    d: "M210.3,234.4c-3-7.2-17.2-14.8-20.8-7.3C186,234.5,210.3,234.4,210.3,234.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1315_",
    className: "st3",
    d: "M209,241.1c1.8-2.6,19.6-9.3,20.5-2.6C230.4,245.2,209,241.1,209,241.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1184_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1245_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1281_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1288_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.7,188.3c-121.2,0-119.8,2-119.8-4.9c0-87.2-1.9-87.9,4.9-87.9c121.2,0,119.8-2,119.8,4.9v82.9 C306.6,186.1,304.4,188.3,301.7,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.6,189.1c-21.8,0-27.5-0.4-29.4-2.3c-0.9-0.9-0.9-2-0.9-3.2l0-0.2c0-18.7-0.1-33.3-0.2-45 c-0.2-32.4-0.2-40.1,2.1-42.4c0.9-0.9,2.2-0.9,3.5-0.9c27.3,0,48.1-0.1,64.7-0.2c43.3-0.2,52.3-0.3,54.8,2.2 c0.9,0.9,0.9,2,0.9,3.2v0.2v82.9c0,3-2.5,5.5-5.5,5.5c-27.3,0-48.1,0.1-64.7,0.2C226.7,189.1,218.4,189.1,211.6,189.1z  M276.8,95.8c-6.8,0-15.1,0-25.3,0.1c-16.7,0.1-37.4,0.2-64.7,0.2c-1.3,0-2.1,0-2.7,0.6c-2,2-2,11.2-1.8,41.6 c0.1,11.7,0.2,26.3,0.2,45.1l0,0.2c0,1.2,0,1.9,0.5,2.4c2.1,2.1,13.1,2.1,53.9,1.9c16.7-0.1,37.4-0.2,64.7-0.2 c2.4,0,4.3-1.9,4.3-4.3v-83.2c0-1.2,0-1.9-0.5-2.4C303.9,96.2,297.3,95.8,276.8,95.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1287_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M306.6,100.1H182c0-2.5,2.1-4.6,4.6-4.6C309.4,95.5,306.6,93.8,306.6,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M307.2,100.7H181.4v-0.6c0-2.9,2.3-5.2,5.2-5.2c26.5,0,46.8-0.1,63.2-0.1c46.1-0.2,54.4-0.2,56.7,2.1 c0.8,0.8,0.8,1.8,0.8,2.8L307.2,100.7z M182.6,99.6h123.5c0-0.9,0-1.4-0.4-1.8c-2-2-13.4-1.9-55.9-1.8 c-16.4,0.1-36.7,0.1-63.2,0.1C184.5,96.1,182.8,97.6,182.6,99.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1282_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1286_",
    className: "st7",
    d: "M301.3,99.1c1.4,0,2,0.1,2-0.5c0-1.4,0.1-2-0.5-2c-1.4,0-2-0.1-2,0.5 C300.8,98.5,300.7,99.1,301.3,99.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1283_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1285_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.3,98.9c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.3,0-0.4l1.4-1.4c0.1-0.1,0.3-0.1,0.4,0s0.1,0.3,0,0.4 l-1.5,1.4C301.5,98.8,301.4,98.9,301.3,98.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1284_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.8,98.9c-0.1,0-0.1,0-0.2-0.1l-1.4-1.4c-0.1-0.1-0.1-0.3,0-0.4s0.3-0.1,0.4,0l1.5,1.4 c0.1,0.1,0.1,0.3,0,0.4C302.9,98.8,302.8,98.9,302.8,98.9z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1246_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1267_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1277_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1280_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.7,107.9h-12.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h12.3c0.2,0,0.3,0.1,0.3,0.3 C201,107.7,200.9,107.9,200.7,107.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1279_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M200.7,176.6h-12.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h12.3c0.2,0,0.3,0.1,0.3,0.3 C201,176.4,200.9,176.6,200.7,176.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1278_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M188.4,176.6c-0.2,0-0.3-0.1-0.3-0.3v-68.7c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3v68.7 C188.7,176.4,188.6,176.6,188.4,176.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1273_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1276_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M205.8,114.1h-10c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h10c0.2,0,0.3,0.1,0.3,0.3 C206,114,205.9,114.1,205.8,114.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1275_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M205.8,170.3h-10c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h10c0.2,0,0.3,0.1,0.3,0.3 S205.9,170.3,205.8,170.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1274_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M195.7,170.3c-0.2,0-0.3-0.1-0.3-0.3v-56.1c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3V170 C196,170.1,195.9,170.3,195.7,170.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1269_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1272_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.9,122.5h-7.1c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h7.1c0.2,0,0.3,0.1,0.3,0.3 S212.1,122.5,211.9,122.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1271_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M211.9,161.9h-7.1c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h7.1c0.2,0,0.3,0.1,0.3,0.3 S212.1,161.9,211.9,161.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1270_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M204.9,161.9c-0.2,0-0.3-0.1-0.3-0.3v-39.4c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3v39.4 C205.2,161.8,205,161.9,204.9,161.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1268_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M212.9,161.9c-0.2,0-0.3-0.1-0.3-0.3v-9.8c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3v9.8 C213.2,161.8,213.1,161.9,212.9,161.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1255_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M215.2,132.9h-10.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3h10.3c0.2,0,0.3,0.1,0.3,0.3 C215.5,132.8,215.4,132.9,215.2,132.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1247_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1266_",
    className: "st8",
    d: "M214.8,109.8c-24.4,0-23.7,0.3-23.7-0.7c0-3.1-0.2-3.8,0.7-3.8c24.4,0,23.7-0.3,23.7,0.7 C215.5,109,215.7,109.8,214.8,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1265_",
    className: "st9",
    d: "M224.4,116.3c-24.4,0-23.7,0.3-23.7-0.7c0-3.1-0.2-3.8,0.7-3.8c24.4,0,23.7-0.3,23.7,0.7 C225.1,115.5,225.3,116.3,224.4,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1264_",
    className: "st10",
    d: "M214.8,124.5c-6.6,0-7.1,0.2-7.1-0.7c0-3.1-0.2-3.8,0.7-3.8c6.6,0,7.1-0.2,7.1,0.7 C215.5,123.7,215.7,124.5,214.8,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1258_",
    className: "st10",
    d: "M216.1,163.9c-6.6,0-7.1,0.2-7.1-0.7c0-3.1-0.2-3.8,0.7-3.8c6.6,0,7.1-0.2,7.1,0.7 C216.8,163.1,217,163.9,216.1,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1257_",
    className: "st10",
    d: "M216.1,154.2c-6.6,0-7.1,0.2-7.1-0.7c0-3.1-0.2-3.8,0.7-3.8c6.6,0,7.1-0.2,7.1,0.7 C216.8,153.4,217,154.2,216.1,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1254_",
    className: "st9",
    d: "M219.3,172.1c-18.9,0-18.5,0.3-18.5-0.7c0-3.1-0.2-3.8,0.7-3.8h17.8 c0.4,0,0.7,0.3,0.7,0.7v3.2C219.9,171.8,219.6,172.1,219.3,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1259_",
    className: "st9",
    d: "M241.4,172.1h-17.8c-0.4,0-0.7-0.3-0.7-0.7v-3.2c0-0.4,0.3-0.7,0.7-0.7h17.8 c0.4,0,0.7,0.3,0.7,0.7v3.2C242,171.8,241.7,172.1,241.4,172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1260_",
    className: "st10",
    d: "M265.7,144.7h-17.8c-0.4,0-0.7-0.3-0.7-0.7c0-3.1-0.2-3.8,0.7-3.8h17.8 c0.4,0,0.7,0.3,0.7,0.7v3.2C266.4,144.4,266.1,144.7,265.7,144.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1253_",
    className: "st8",
    d: "M204.2,178.5c-11.3,0-11.5,0.3-11.5-0.7c0-3.1-0.2-3.8,0.7-3.8c11.3,0,11.5-0.3,11.5,0.7 v3.2C204.9,178.2,204.6,178.5,204.2,178.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1252_",
    className: "st9",
    d: "M262.1,109.8c-44.7,0-42.5,0.3-42.5-0.7c0-3.1-0.2-3.8,0.7-3.8c44.7,0,42.5-0.3,42.5,0.7 v3.2C262.7,109.5,262.4,109.8,262.1,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1251_",
    className: "st8",
    d: "M254,154.2c-35.7,0-34.1,0.3-34.1-0.6c0-3.3-0.2-3.9,0.6-3.9H254c0.3,0,0.6,0.3,0.6,0.6 v3.3C254.7,153.9,254.4,154.2,254,154.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1249_",
    className: "st8",
    d: "M250.2,134.9c-44.7,0-42.5,0.3-42.5-0.7c0-3.1-0.2-3.8,0.7-3.8c44.7,0,42.5-0.3,42.5,0.7 v3.2C250.9,134.6,250.6,134.9,250.2,134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1248_",
    className: "st9",
    d: "M280.8,109.8c-10.3,0-10.2,0.2-10.2-0.4c0-3.7-0.2-4.1,0.4-4.1c10.3,0,10.2-0.2,10.2,0.4 C281.2,109.4,281.4,109.8,280.8,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1250_",
    className: "st10",
    d: "M293.5,109.8c-10.3,0-10.2,0.2-10.2-0.4c0-3.7-0.2-4.1,0.4-4.1 c10.3,0,10.2-0.2,10.2,0.4C293.9,109.4,294.1,109.8,293.5,109.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1211_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1237_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1244_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M347.2,266c-105.8,0-103.7,1.6-103.7-3.9c0-61.8-1.5-62.9,3.9-62.9c105.8,0,103.7-1.6,103.7,3.9v59 C351,264.3,349.3,266,347.2,266z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M268.1,266.8c-18.8,0-23.1-0.3-24.6-1.9c-0.7-0.7-0.7-1.6-0.7-2.5l0-0.3c0-13.2-0.1-23.6-0.1-31.9 c-0.1-23.3-0.2-28.8,1.7-30.7c0.7-0.7,1.7-0.8,2.9-0.8c24.2,0,42.4-0.1,57-0.1c37.8-0.2,44.6-0.2,46.6,1.8 c0.7,0.7,0.7,1.6,0.7,2.5l0,0.3v59c0,2.4-2,4.4-4.4,4.4c-24.2,0-42.4,0.1-57,0.1C281.2,266.7,274,266.8,268.1,266.8z  M326.1,199.6c-5.8,0-13,0-21.8,0.1c-14.6,0.1-32.8,0.1-57,0.1c-1.1,0-1.7,0.1-2.1,0.5c-1.5,1.5-1.5,8.7-1.3,29.9 c0.1,8.3,0.1,18.7,0.1,32l0,0.3c0,0.9,0,1.3,0.3,1.7c1.6,1.7,11,1.6,45.8,1.5c14.6-0.1,32.8-0.1,57-0.1c1.8,0,3.3-1.5,3.3-3.3 l0-59.3c0-0.9,0-1.3-0.3-1.7C348.9,199.9,343.3,199.6,326.1,199.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1243_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M351,202.6H243.4c0-1.8,1.5-3.3,3.3-3.3C354.7,199.3,351,198,351,202.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M351.6,203.1H242.9v-0.6c0-2.1,1.7-3.9,3.9-3.9c23.4,0,41.3-0.1,55.7-0.1c40.7-0.1,46.9-0.2,48.6,1.6 c0.6,0.6,0.5,1.3,0.5,2c0,0.1,0,0.3,0,0.4L351.6,203.1L351.6,203.1z M244,202h106.4c0-0.5,0-0.8-0.2-1 c-1.4-1.4-11.2-1.4-47.8-1.3c-14.4,0-32.3,0.1-55.7,0.1C245.4,199.8,244.3,200.8,244,202z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1238_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1242_",
    className: "st7",
    d: "M346.4,201.8c0.9,0,1.8,0.2,1.8-0.4c0-0.7,0.2-1.4-0.4-1.4c-0.9,0-1.8-0.2-1.8,0.4 C346,201.1,345.8,201.8,346.4,201.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1239_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1241_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M346.4,201.7c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.3,0-0.4l1.3-1c0.1-0.1,0.3-0.1,0.4,0 c0.1,0.1,0.1,0.3,0,0.4l-1.3,1C346.6,201.7,346.5,201.7,346.4,201.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1240_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M347.7,201.7c-0.1,0-0.1,0-0.2-0.1l-1.3-1c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0l1.3,1 c0.1,0.1,0.1,0.3,0,0.4C347.9,201.7,347.8,201.7,347.7,201.7z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1212_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1230_",
    className: "st11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1377_",
    className: "st12",
    d: "M286.5,260.8c0-1.8-0.2-2.7,0.6-2.7c1.8,0,2.7-0.2,2.7,0.6c0,1.8,0.2,2.7-0.6,2.7 C287.3,261.4,286.5,261.6,286.5,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1376_",
    className: "st12",
    d: "M279.2,260.8c0-1.8-0.2-2.7,0.6-2.7c1.8,0,2.7-0.2,2.7,0.6c0,1.8,0.2,2.7-0.6,2.7 C280,261.4,279.2,261.6,279.2,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1375_",
    className: "st12",
    d: "M271.4,260.8c0-1.8-0.2-2.7,0.6-2.7c1.8,0,2.7-0.2,2.7,0.6c0,1.8,0.2,2.7-0.6,2.7 C272.2,261.4,271.4,261.6,271.4,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1374_",
    className: "st12",
    d: "M265,260.8c0-1.8-0.2-2.7,0.6-2.7c1.8,0,2.7-0.2,2.7,0.6c0,1.8,0.2,2.7-0.6,2.7 C265.9,261.4,265,261.6,265,260.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1373_",
    className: "st12",
    d: "M257.5,260.8c0-1.8-0.2-2.7,0.6-2.7c1.8,0,2.7-0.2,2.7,0.6c0,1.8,0.2,2.7-0.6,2.7 C258.4,261.4,257.5,261.6,257.5,260.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1226_",
    className: "st8",
    d: "M271.2,210.6c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C272.2,209.3,272.4,210.6,271.2,210.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1225_",
    className: "st13",
    d: "M320.3,210.6c-45.8,0-44.2,0.5-44.2-1c0-1-0.2-2.3,1-2.3c45.8,0,44.2-0.5,44.2,1v1.3 C321.3,210.2,320.8,210.6,320.3,210.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1224_",
    className: "st13",
    d: "M320.3,225.2c-45.8,0-44.2,0.5-44.2-1c0-1-0.2-2.3,1-2.3h43.2c0.5,0,1,0.4,1,1v1.3 C321.3,224.8,320.8,225.2,320.3,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1223_",
    className: "st13",
    d: "M320.3,239.9h-43.2c-1.4,0-1.4-3.3,0-3.3h43.2c0.5,0,1,0.4,1,1v1.3 C321.3,239.4,320.8,239.9,320.3,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1222_",
    className: "st13",
    d: "M320.3,254.5c-45.8,0-44.2,0.5-44.2-1c0-1-0.2-2.3,1-2.3c45.8,0,44.2-0.5,44.2,1 C321.3,253.2,321.5,254.5,320.3,254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1221_",
    className: "st8",
    d: "M271.2,217.9c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C272.2,216.6,272.4,217.9,271.2,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1220_",
    className: "st8",
    d: "M271.2,225.2c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C272.2,223.9,272.4,225.2,271.2,225.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1219_",
    className: "st8",
    d: "M271.2,232.5c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C272.2,231.2,272.4,232.5,271.2,232.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1218_",
    className: "st8",
    d: "M271.2,239.9c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1v1.3 C272.2,239.4,271.8,239.9,271.2,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1217_",
    className: "st8",
    d: "M271.2,247.2c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C272.2,245.8,272.4,247.2,271.2,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1216_",
    className: "st8",
    d: "M271.2,254.5c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C272.2,253.2,272.4,254.5,271.2,254.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1215_",
    className: "st8",
    d: "M335.9,217.9c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C336.9,216.6,337.1,217.9,335.9,217.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1214_",
    className: "st8",
    d: "M335.9,232.5c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C336.9,231.2,337.1,232.5,335.9,232.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1213_",
    className: "st8",
    d: "M335.9,247.2c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C336.9,245.8,337.1,247.2,335.9,247.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1229_",
    className: "st10",
    d: "M303.7,218H291c-0.5,0-1-0.4-1-1v-1.3c0-0.6,0.4-1,1-1h12.7c0.5,0,1,0.4,1,1v1.3 C304.7,217.5,304.3,218,303.7,218z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1228_",
    className: "st10",
    d: "M303.7,232.6c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3h12.7c0.5,0,1,0.4,1,1v1.3 C304.7,232.1,304.3,232.6,303.7,232.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1227_",
    className: "st10",
    d: "M303.7,247.2c-13.2,0-13.7,0.4-13.7-1c0-1-0.2-2.3,1-2.3c13.2,0,13.7-0.4,13.7,1 C304.7,245.9,304.9,247.2,303.7,247.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1185_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1203_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1210_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M377.9,221.6c-114.8,0-112.1,1.6-112.1-4.2v-63.7c0-2.3,1.9-4.2,4.2-4.2c114.8,0,112.1-1.6,112.1,4.2v63.7 C382.1,219.8,380.2,221.6,377.9,221.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M294.3,222.4c-21.8,0-26.7-0.4-28.3-2c-0.7-0.7-0.7-1.6-0.7-2.5l0-0.4v-63.7c0-2.6,2.1-4.7,4.7-4.7 c25,0,44.2-0.1,59.6-0.1c42.6-0.2,50.3-0.2,52.4,1.9c0.7,0.7,0.7,1.6,0.7,2.5l0,0.4v63.7c0,2.6-2.1,4.7-4.7,4.7 c-25,0-44.2,0.1-59.6,0.1C308.6,222.3,300.7,222.4,294.3,222.4z M353.2,149.9c-6.4,0-14.2,0-23.6,0.1 c-15.4,0.1-34.5,0.1-59.6,0.1c-2,0-3.7,1.6-3.7,3.7l0,64.1c0,0.9,0,1.4,0.4,1.8c1.8,1.8,12.3,1.8,51.6,1.6 c15.4-0.1,34.5-0.1,59.6-0.1c2,0,3.7-1.6,3.7-3.7l0-64.1c0-0.9,0-1.4-0.4-1.8C379.8,150.2,373.4,149.9,353.2,149.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1209_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M382.1,153.1H265.8c0-2,1.6-3.6,3.6-3.6C385.9,149.6,382.1,148.2,382.1,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M382.6,153.7H265.3v-0.5c0-2.3,1.8-4.1,4.1-4.1c25.3,0,44.6-0.1,60.1-0.1c43-0.1,50.7-0.2,52.6,1.7 c0.6,0.6,0.6,1.3,0.5,2.1c0,0.1,0,0.3,0,0.4L382.6,153.7L382.6,153.7z M266.4,152.6h115.2c0-0.6,0-1-0.2-1.2 c-1.5-1.6-11.2-1.5-51.8-1.4c-15.5,0.1-34.8,0.1-60.1,0.1C267.9,150.1,266.7,151.2,266.4,152.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1204_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1208_",
    className: "st7",
    d: "M377,152.3c1.2,0,1.9,0.2,1.9-0.4c0-0.7,0.2-1.5-0.4-1.5c-1.2,0-1.9-0.2-1.9,0.4 C376.6,151.5,376.5,152.3,377,152.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1205_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1207_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M377.1,152.2c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.3,0-0.4l1.4-1.1c0.1-0.1,0.3-0.1,0.4,0 c0.1,0.1,0.1,0.3,0,0.4l-1.4,1.1C377.2,152.2,377.2,152.2,377.1,152.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1206_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.5,152.2c-0.1,0-0.1,0-0.2-0.1L377,151c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.3-0.1,0.4,0l1.4,1.1 c0.1,0.1,0.1,0.3,0,0.4C378.6,152.1,378.5,152.2,378.5,152.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1186_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1367_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1370_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.5,159.1h-10.2c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h10.2c0.1,0,0.2,0.1,0.2,0.2 C285.8,159,285.7,159.1,285.5,159.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1369_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.5,216h-10.2c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h10.2c0.1,0,0.2,0.1,0.2,0.2 S285.7,216,285.5,216z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1368_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M275.4,216c-0.1,0-0.2-0.1-0.2-0.2v-56.9c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2v56.9 C275.6,215.9,275.5,216,275.4,216z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1262_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1362_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.2,171.2h-5.8c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h5.8c0.1,0,0.2,0.1,0.2,0.2 S285.3,171.2,285.2,171.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1361_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M285.2,203.9h-5.8c-0.1,0-0.2-0.1-0.2-0.2c0-0.1,0.1-0.2,0.2-0.2h5.8c0.1,0,0.2,0.1,0.2,0.2 C285.4,203.8,285.3,203.9,285.2,203.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1263_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M279.3,203.9c-0.1,0-0.2-0.1-0.2-0.2V171c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2v32.7 C279.6,203.8,279.5,203.9,279.3,203.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1256_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M287.9,179.8h-8.6c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h8.6c0.1,0,0.2,0.1,0.2,0.2 C288.1,179.7,288,179.8,287.9,179.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1201_",
    className: "st8",
    d: "M297.2,160.7h-19.1c-0.3,0-0.6-0.3-0.6-0.6v-2.6c0-0.3,0.3-0.6,0.6-0.6 c20.2,0,19.6-0.2,19.6,0.6v2.6C297.8,160.5,297.5,160.7,297.2,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1199_",
    className: "st10",
    d: "M287.6,172.9h-5.3c-0.3,0-0.6-0.3-0.6-0.6v-2.6c0-0.3,0.3-0.6,0.6-0.6h5.3 c0.3,0,0.6,0.3,0.6,0.6v2.6C288.2,172.6,287.9,172.9,287.6,172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1193_",
    className: "st8",
    d: "M288.4,217.7h-9c-0.3,0-0.6-0.3-0.6-0.6v-2.6c0-0.3,0.3-0.6,0.6-0.6h9 c0.3,0,0.6,0.3,0.6,0.6v2.6C289,217.4,288.7,217.7,288.4,217.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1200_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M339.3,179.8h-23.7c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h23.7c0.1,0,0.2,0.1,0.2,0.2 C339.6,179.7,339.5,179.8,339.3,179.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1192_",
    className: "st9",
    d: "M336.4,160.7c-37,0-35.2,0.3-35.2-0.6c0-2.5-0.2-3.2,0.6-3.2c37,0,35.2-0.3,35.2,0.6 C336.9,160,337.1,160.7,336.4,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1191_",
    className: "st8",
    d: "M310.7,205.5h-27.8c-0.3,0-0.5-0.2-0.5-0.5v-2.7c0-0.3,0.2-0.5,0.5-0.5h27.8 c0.3,0,0.5,0.2,0.5,0.5v2.7C311.2,205.3,311,205.5,310.7,205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1190_",
    className: "st8",
    d: "M316.9,181.5h-34.7c-0.3,0-0.6-0.3-0.6-0.6v-2.6c0-0.3,0.3-0.6,0.6-0.6h34.7 c0.3,0,0.6,0.3,0.6,0.6v2.6C317.5,181.2,317.2,181.5,316.9,181.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1261_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337.3,204.9h-10.5c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h10.5c0.1,0,0.2,0.1,0.2,0.2 S337.4,204.9,337.3,204.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1363_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337.3,196.6h-10.5c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h10.5c0.1,0,0.2,0.1,0.2,0.2 S337.4,196.6,337.3,196.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1364_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M337.3,188.3h-10.5c-0.1,0-0.2-0.1-0.2-0.2s0.1-0.2,0.2-0.2h10.5c0.1,0,0.2,0.1,0.2,0.2 C337.5,188.2,337.4,188.3,337.3,188.3z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1189_",
    className: "st9",
    d: "M330.8,181.6c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3 C331.1,180.8,331.3,181.6,330.8,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1372_",
    className: "st9",
    d: "M308.2,192.4h-18.5c-0.3,0-0.5-0.2-0.5-0.5v-2.7c0-0.3,0.2-0.5,0.5-0.5h18.5 c0.3,0,0.5,0.2,0.5,0.5v2.7C308.7,192.2,308.5,192.4,308.2,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1188_",
    className: "st10",
    d: "M341.3,181.6c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3 C341.6,180.8,341.9,181.6,341.3,181.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1194_",
    className: "st9",
    d: "M330.8,189.9c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3 C331.1,189.1,331.3,189.9,330.8,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1187_",
    className: "st10",
    d: "M341.3,189.9c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3v3.1 C341.6,189.8,341.5,189.9,341.3,189.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1196_",
    className: "st9",
    d: "M330.8,198.2c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3 C331.1,197.5,331.3,198.2,330.8,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1195_",
    className: "st10",
    d: "M341.3,198.2c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3 C341.6,197.5,341.9,198.2,341.3,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1198_",
    className: "st9",
    d: "M330.8,206.6c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3 C331.1,205.8,331.3,206.6,330.8,206.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1197_",
    className: "st10",
    d: "M341.3,206.6c-8.1,0-8.4,0.2-8.4-0.3c0-2.6-0.2-3.4,0.3-3.4c8.1,0,8.4-0.2,8.4,0.3 C341.6,205.8,341.9,206.6,341.3,206.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1202_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M332,204.9c-0.1,0-0.2-0.1-0.2-0.2v-25.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2v25.1 C332.2,204.8,332.1,204.9,332,204.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1365_",
    className: "st10",
    d: "M346.5,160.7c-5.4,0-5.9,0.2-5.9-0.6c0-2.5-0.2-3.2,0.6-3.2c5.4,0,5.9-0.2,5.9,0.6 C347,160,347.2,160.7,346.5,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1366_",
    className: "st10",
    d: "M357.5,160.7c-5.4,0-5.9,0.2-5.9-0.6c0-2.5-0.2-3.2,0.6-3.2c5.4,0,5.9-0.2,5.9,0.6 C358.1,160,358.2,160.7,357.5,160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1371_",
    className: "st10",
    d: "M368.5,160.7c-5.4,0-5.9,0.2-5.9-0.6c0-2.5-0.2-3.2,0.6-3.2c5.4,0,5.9-0.2,5.9,0.6 C369.1,160,369.3,160.7,368.5,160.7z"
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_550_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_848_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 104.1,
    cy: 188.4,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M104.1,209.4c-11.6,0-21-9.4-21-21s9.4-21,21-21s21,9.4,21,21S115.6,209.4,104.1,209.4z M104.1,169.4 c-10.5,0-19,8.5-19,19s8.5,19,19,19s19-8.5,19-19S114.5,169.4,104.1,169.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_551_",
    className: "st15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_557_",
    className: "st16",
    d: "M103.7,170.7c1.5-0.5,2.2,1.8,0.7,2.2C102.9,173.4,102.2,171.2,103.7,170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_846_",
    className: "st16",
    d: "M112.5,172.9c1.5,0.3,1,2.6-0.5,2.3C110.5,174.8,111,172.5,112.5,172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_845_",
    className: "st16",
    d: "M119.6,180.1c1.1,1.1-0.6,2.8-1.7,1.6C116.8,180.6,118.5,179,119.6,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_844_",
    className: "st16",
    d: "M119.4,188.3c0-1.6,2.4-1.5,2.4,0C121.7,189.9,119.3,189.9,119.4,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_556_",
    className: "st16",
    d: "M95.6,172.9c-1.5,0.3-1,2.6,0.5,2.3C97.6,174.8,97.1,172.5,95.6,172.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_842_",
    className: "st16",
    d: "M88.5,180.1c-1.1,1.1,0.6,2.8,1.7,1.6C91.3,180.6,89.6,179,88.5,180.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_841_",
    className: "st16",
    d: "M88.7,188.3c0-1.6-2.4-1.5-2.4,0C86.4,189.9,88.7,189.9,88.7,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_554_",
    className: "st16",
    d: "M103.7,206c1.5,0.5,2.2-1.8,0.7-2.2C102.9,203.2,102.2,205.5,103.7,206z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_553_",
    className: "st16",
    d: "M112.5,203.8c1.5-0.3,1-2.6-0.5-2.3C110.5,201.9,111,204.2,112.5,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_838_",
    className: "st16",
    d: "M119.6,196.6c1.1-1.1-0.6-2.8-1.7-1.6C116.8,196.1,118.5,197.7,119.6,196.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_552_",
    className: "st16",
    d: "M95.6,203.8c-1.5-0.3-1-2.6,0.5-2.3C97.6,201.9,97.1,204.2,95.6,203.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_836_",
    className: "st16",
    d: "M88.5,196.6c-1.1-1.1,0.6-2.8,1.7-1.6C91.3,196.1,89.6,197.7,88.5,196.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_834_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M104.5,189.7c0,0.1-0.1,0.1-0.2,0.2c-0.2,0.1-0.3,0.1-0.5,0l-11.3-6.5c-0.2-0.1-0.3-0.4-0.2-0.7 c0.1-0.2,0.4-0.3,0.7-0.2l10.6,6.1l0.7-12.5c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5l-0.7,13.3 C104.5,189.5,104.5,189.6,104.5,189.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_559_"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 77.6,
    y: 205.1,
    width: 224.2,
    height: 162.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_797_",
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_819_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_549_",
    className: "st16",
    points: "209.5,295.8 180.2,295.8 188.2,278.5 201.5,278.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_548_",
    className: "st18",
    d: "M240.2,280.7c-96.8,0-92.8,0.8-92.8-1.9c0-65.1-0.8-62.8,1.9-62.8 c96.8,0,92.8-0.8,92.8,1.9C242.1,283,242.9,280.7,240.2,280.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_830_",
    className: "st19",
    d: "M238.1,268.2c-92,0-88.6,0.9-88.6-1.9c0-49.1-0.8-48.4,1.9-48.4c92,0,88.6-0.9,88.6,1.9 C240,268.9,240.8,268.2,238.1,268.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_822_",
    className: "st16",
    d: "M194.6,277.2c-3.5,0-3.5-5.3,0-5.3C198.1,272,198.1,277.2,194.6,277.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_547_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1150_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1157_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227,264.6c-68.4,0-67,1-67-2.5c0-39.9-0.9-40.6,2.5-40.6c68.4,0,67-1,67,2.5 C229.5,263.9,230.4,264.6,227,264.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M176.2,265c-12.3,0-15.1-0.2-16.1-1.2c-0.4-0.4-0.4-1-0.4-1.6l0-0.2c0-8.6,0-15.2-0.1-20.6 c-0.1-15-0.1-18.6,1.1-19.7c0.5-0.5,1.1-0.5,1.8-0.5c15.4,0,27.1-0.1,36.5-0.1c24.7-0.1,29.1-0.1,30.4,1.1 c0.4,0.4,0.4,1,0.4,1.6l0,0.2c0,8.6,0,15.2,0.1,20.6c0.1,15,0.1,18.6-1.1,19.7c-0.5,0.5-1.1,0.5-1.8,0.5 c-15.4,0-27.1,0.1-36.5,0.1C184.7,265,180,265,176.2,265z M213,221.7c-3.8,0-8.4,0-14,0c-9.4,0-21,0.1-36.5,0.1 c-0.6,0-1.1,0-1.4,0.3c-1,1-1,5.2-0.9,19.3c0,5.4,0.1,12.1,0.1,20.6l0,0.2c0,0.6,0,0.9,0.2,1.1c1.1,1.1,7.2,1.1,29.9,1 c9.4,0,21-0.1,36.5-0.1c0.6,0,1.1,0,1.4-0.3c1-1,1-5.2,0.9-19.3c0-5.4-0.1-12.1-0.1-20.6l0-0.2c0-0.6,0-0.9-0.2-1.1 C228.1,221.9,224.5,221.7,213,221.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1156_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.5,223.7H160c0-1.2,1-2.1,2.1-2.1C231.7,221.5,229.5,220.6,229.5,223.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M229.8,224h-70.1v-0.3c0-1.4,1.1-2.5,2.5-2.5c16.1,0,28.6-0.1,37.7-0.1c24.1-0.1,28.5-0.1,29.6,1 c0.4,0.4,0.3,0.8,0.3,1.3c0,0.1,0,0.2,0,0.3L229.8,224L229.8,224z M160.4,223.3h68.8c0-0.4,0-0.6-0.2-0.8 c-0.9-0.9-6.9-0.9-29.1-0.8c-9.1,0-21.6,0.1-37.7,0.1C161.3,221.8,160.5,222.5,160.4,223.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1151_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1155_",
    className: "st7",
    d: "M226.5,223.2h0.9c0.3,0,0.4-1.2,0-1.2h-0.9c-0.4,0-0.2,1.2-0.2,0.9 C226.2,223.1,226.3,223.2,226.5,223.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1152_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1154_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M226.5,223.1c0,0-0.1,0-0.1-0.1c-0.1-0.1,0-0.2,0-0.2l0.8-0.7c0.1-0.1,0.2,0,0.2,0 c0.1,0.1,0,0.2,0,0.2l-0.8,0.7C226.6,223.1,226.6,223.1,226.5,223.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1153_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.3,223.1c0,0-0.1,0-0.1,0l-0.8-0.7c-0.1-0.1-0.1-0.2,0-0.2c0.1-0.1,0.2-0.1,0.2,0l0.8,0.7 c0.1,0.1,0.1,0.2,0,0.2C227.4,223.1,227.4,223.1,227.3,223.1z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_562_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1149_",
    className: "st8",
    d: "M187.2,233.2c-18.3,0-17.8,0.2-17.8-0.4c0-1.5-0.1-2.1,0.4-2.1 c18.3,0,17.8-0.2,17.8,0.4C187.6,232.7,187.8,233.2,187.2,233.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1148_",
    className: "st8",
    d: "M200.9,255.4c-32.9,0-31.5,0.3-31.5-0.6c0-1.2-0.1-1.9,0.6-1.9 c32.9,0,31.5-0.3,31.5,0.6C201.5,254.6,201.6,255.4,200.9,255.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_827_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1147_",
    className: "st10",
    d: "M167.1,233.3c-1.4,0-2.1,0.1-2.1-0.5c0-1.4-0.1-2.1,0.5-2.1c1.4,0,2.1-0.1,2.1,0.5 C167.6,232.6,167.7,233.3,167.1,233.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1146_",
    className: "st10",
    d: "M167.1,238.9c-1.4,0-2.1,0.1-2.1-0.5c0-1.4-0.1-2.1,0.5-2.1c1.4,0,2.1-0.1,2.1,0.5 C167.6,238.2,167.7,238.9,167.1,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1138_",
    className: "st10",
    d: "M167.1,244.8c-1.4,0-2.1,0.1-2.1-0.5c0-1.4-0.1-2.1,0.5-2.1c1.4,0,2.1-0.1,2.1,0.5 C167.6,244.1,167.7,244.8,167.1,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1137_",
    className: "st10",
    d: "M167.1,249.7c-1.4,0-2.1,0.1-2.1-0.5c0-1.4-0.1-2.1,0.5-2.1c1.4,0,2.1-0.1,2.1,0.5 C167.6,249,167.7,249.7,167.1,249.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_828_",
    className: "st10",
    d: "M167.1,255.4c-1.4,0-2.1,0.1-2.1-0.5c0-1.4-0.1-2.1,0.5-2.1c1.4,0,2.1-0.1,2.1,0.5 C167.6,254.7,167.7,255.4,167.1,255.4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_826_",
    className: "st13",
    d: "M223.7,233.3c-34.9,0-33.7,0.4-33.7-0.8c0-0.8-0.2-1.8,0.8-1.8 c34.9,0,33.7-0.4,33.7,0.8C224.5,232.3,224.6,233.3,223.7,233.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_825_",
    className: "st8",
    d: "M187.2,238.8c-18.3,0-17.8,0.2-17.8-0.4c0-1.5-0.1-2.1,0.4-2.1 c18.3,0,17.8-0.2,17.8,0.4C187.6,238.2,187.8,238.8,187.2,238.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_824_",
    className: "st13",
    d: "M220.3,238.9c-31.3,0-30.3,0.3-30.3-0.7c0-0.9-0.2-1.8,0.7-1.8 c31.3,0,30.3-0.3,30.3,0.7C221,237.9,221.2,238.9,220.3,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_823_",
    className: "st8",
    d: "M187.2,244.8c-18.3,0-17.8,0.2-17.8-0.4c0-1.5-0.1-2.1,0.4-2.1 c18.3,0,17.8-0.2,17.8,0.4C187.6,244.2,187.8,244.8,187.2,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_821_",
    className: "st13",
    d: "M214.6,244.8c-25.3,0-24.6,0.3-24.6-0.7c0-1-0.2-1.9,0.7-1.9c25.3,0,24.6-0.3,24.6,0.7 C215.2,243.9,215.4,244.8,214.6,244.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_820_",
    className: "st13",
    d: "M214.6,251c-25.3,0-24.6,0.3-24.6-0.7c0-1-0.2-1.9,0.7-1.9c25.3,0,24.6-0.3,24.6,0.7 C215.2,250,215.4,251,214.6,251z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_705_",
    className: "st8",
    d: "M187.2,250.7c-18.3,0-17.8,0.2-17.8-0.4c0-1.5-0.1-2.1,0.4-2.1 c18.3,0,17.8-0.2,17.8,0.4C187.6,250.1,187.8,250.7,187.2,250.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_703_",
    className: "st13",
    d: "M223.9,255.4c-21.9,0-21.3,0.3-21.3-0.6c0-1-0.2-2,0.6-2c21.9,0,21.3-0.3,21.3,0.6 C224.5,254.5,224.7,255.4,223.9,255.4z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_798_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_808_",
    className: "st20",
    d: "M292.3,316.1c0-21.1,0.2-20.2-0.4-20.2c-187.4,0-177.9-0.2-177.9,0.4v19.8 C114,316.6,292.3,316.9,292.3,316.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_805_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st21",
    d: "M280.8,312.3c-70.7,0-68,0.7-68-1.5c0-9.7-0.5-11.2,1.5-11.2c70.7,0,68-0.7,68,1.5 C282.3,310.8,282.8,312.3,280.8,312.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M247.6,308.5c-3.5,0-3.5-5.3,0-5.3C251.1,303.2,251.1,308.5,247.6,308.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_802_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_90_",
    className: "st21",
    d: "M205.4,312.3c-70.7,0-68,0.7-68-1.5c0-9.7-0.5-11.2,1.5-11.2c70.7,0,68-0.7,68,1.5 C207,310.8,207.4,312.3,205.4,312.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_89_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M172.2,308.5c-3.5,0-3.5-5.3,0-5.3C175.7,303.2,175.7,308.5,172.2,308.5z"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_801_",
    x: 143.2,
    y: 316.5,
    className: "st21",
    width: 126.3,
    height: 5.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_800_",
    className: "st20",
    d: "M273.3,317.7l14.8,81.3c0.5,2.7-2.9,2.5-3.3,0.8c-22.9-85.8-23.1-83.4-20.4-83.4 C272.1,316.5,273,316.1,273.3,317.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_799_",
    className: "st20",
    d: "M127.7,317.7c-0.1,0.3-14.8,81.4-14.8,81.8c0.4,2.8,3,1.5,3.3,0.4 c23-86,23.1-83.4,20.4-83.4C128.8,316.5,127.9,316.2,127.7,317.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st20",
    d: "M137.5,333.2c0.1,0.3,25.2,78.9,25.4,79.1c1.7,2.3,3.4-0.1,3.1-1.2 c-20.1-86.8-18.8-84.5-21.1-83.2C138,331.6,137,331.7,137.5,333.2z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 77.6,
    y: 205.1,
    width: 224.2,
    height: 162.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_796_",
    className: "st22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M135.1,307.7l-0.1-0.5c8.5-2.6,7.7-7.1,6.7-12.8c-0.9-5.3-2.1-11.9,4.5-18.7l0.4,0.3 c-6.4,6.5-5.3,12.7-4.3,18.2C143.2,300,144,304.9,135.1,307.7z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 77.6,
    y: 205.1,
    width: 224.2,
    height: 162.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_725_",
    className: "st24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_759_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_771_",
    className: "st25",
    d: "M204.9,388.9c1.7,1.2-6.5,9.5-13.5,10.6l-1.6-2c-0.9-7.2-2.3-4.4,6.5-11L204.9,388.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_770_",
    className: "st26",
    d: "M216.4,397.6c-7.1,4-13,13-16.7,11.4c-3.7-1.6-5.9-12.9-8-15.1c0,0,3.1-3.5,3.1-3.5 c0.9-0.1,0,0,5.4-0.8c0.7,1,1.2,1.8,1.7,2.4c6,6.6,21.6-5.9,23.5-3.6C227.6,390.9,219.3,395.9,216.4,397.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_769_",
    className: "st27",
    d: "M222.7,393.4c-1.6,1.3-3.7,2.7-6.3,4.2c-7.1,4-13,13-16.7,11.4c-3.7-1.6-5.9-12.9-8-15.1 c0,0,3.8-3.6,3.8-3.6l4.7-0.7c0.7,1,1.2,1.8,1.7,2.4c-0.5,2.3-2.2,7.4-1.6,9.6c1.7,6.4,10.5-3.3,17.2-5.9 C219.1,395.1,221.2,394.1,222.7,393.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_768_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M204.9,388.9c-1.7-0.1-9.8,2.2-15,8.7c0,0-17.9-14.9-26.2-37.8l15.5-9.2c0,0,13.2,22.6,17.2,28.6 S204.9,388.9,204.9,388.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M189.9,398l-0.2-0.2c-0.2-0.1-18.1-15.2-26.3-37.9l-0.1-0.2l16-9.4l0.1,0.2c0.1,0.2,13.2,22.6,17.2,28.6 c4,5.9,8.4,9.6,8.4,9.6l0.7,0.5l-0.9,0c-1.4-0.1-9.5,1.9-14.8,8.6L189.9,398z M164,359.9c7.7,21.1,23.8,35.5,25.8,37.2 c4.6-5.6,11.7-8.1,14.4-8.5c-1.3-1.2-4.8-4.5-8-9.3c-3.8-5.6-15.7-25.9-17.1-28.4L164,359.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_767_",
    className: "st25",
    d: "M173,394.9c-0.7,3,15.2,8.6,20,4.8l-1.7-11.8l-14.1,0.4L173,394.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_766_",
    className: "st26",
    d: "M200.6,416.1c-9.7,0-7.4-2.9-16.9-3.6c-9.6-0.7-12.6-2.3-12.4-5.6 c0.2-3.3,5.9-12.1,6.6-15.5c9.1,3.3,6.7,2.4,9.5,3.4c-1.2,6.6-0.6,9.9,6.7,13.1C202.4,411.6,209.8,416.1,200.6,416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_765_",
    className: "st27",
    d: "M204.4,415.5c-0.6,0.4-1.8,0.6-3.9,0.6c-9.7,0-7.4-2.9-16.9-3.6 c-20.1-1.5-10.7-7.4-6.2-19.7c9,1.5,7.1,1.1,9.8,2.1c-0.3,1.8-0.5,3.3-0.5,4.6c-10.9,0.7-15,8.8-2,11 c4.8,0.8,11.4,4.4,14.1,4.7C200.8,415.4,203.2,415.5,204.4,415.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_764_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M196.6,369.3c-3.1,8.2-4.2,24-3.6,30.3c-1.9-2.8-8.5-7.4-20-4.8l7.1-45.8c-19.8-2.4-14.4-1.8-25-3.1 c-3-4.4-11.9-17.2-14.9-21.6c11.1-6.5,9-5.3,11.8-7c4.2,3.1,39.2,8.8,48.6,14C209.8,336.5,199.6,361.1,196.6,369.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M193.4,400.7l-0.6-0.9c-1.8-2.8-8.3-7.3-19.7-4.6l-0.4,0.1l0.1-0.4l7.1-45.5l-24.9-3l-0.1-0.1 l-15.1-21.8l3.9-2.3c5.9-3.5,5.9-3.5,7.2-4.3l1.1-0.6l0.1,0.1c1.9,1.4,10.6,3.4,19.8,5.6c11.1,2.6,23.7,5.6,28.8,8.4 c8.8,4.8,0.7,26-3.1,36.2c-0.3,0.7-0.5,1.4-0.7,2c-3,8-4.2,23.6-3.5,30.2L193.4,400.7z M179.7,393.8c6.8,0,11.1,2.7,13,4.9 c-0.4-7.1,0.8-21.8,3.7-29.5c0.2-0.6,0.5-1.2,0.7-2c3.5-9.3,11.7-31,3.4-35.5c-5.1-2.8-17.6-5.7-28.7-8.3 c-9.4-2.2-17.6-4.1-19.8-5.6l-0.8,0.5c-1.3,0.8-1.3,0.8-7.2,4.3l-3.4,2l14.7,21.2l25.2,3.1l-7.1,45.7 C175.6,394,177.8,393.8,179.7,393.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_763_",
    className: "st30",
    d: "M183.4,394.2l-0.3,0.1c-2.7-0.4-6.1-0.4-10.1,0.6l7.1-45.8l-16.7-2 c-0.6-0.3-14.4-7.1-23.9-11.7l0.8-16.6l8.8-1.6c5.4,13.8,25.2,25.5,42.2,30.5C184.7,371.9,179.7,385.1,183.4,394.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_762_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M184.9,348.8c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.2-0.3c0-0.1,0.1-0.2,0.2-0.2c2.2,0,5.8-0.6,8.2-2.2 c0.1-0.1,0.3,0,0.3,0.1c0.1,0.1,0,0.3-0.1,0.3C190.7,348.2,187.2,348.8,184.9,348.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_761_",
    className: "st14",
    d: "M202.6,404.1c0,0,0-0.1,0.1-0.2c0.1-0.1,0.2-0.3,0.3-0.4c0.2-0.4,0.4-0.8,0.5-1.3 c0.1-0.5,0.2-1,0.3-1.5c0.1-0.4,0.2-0.7,0.2-0.7s0.2,0.3,0.3,0.7c0.2,0.4,0.2,1.1,0.1,1.7c0,0.2-0.1,0.3-0.2,0.5 c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.2,0.1-0.4,0.2-0.6,0.2 C202.7,404,202.6,404.1,202.6,404.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_760_",
    className: "st14",
    d: "M181.1,404.2c0,0,0,0.1,0,0.1c0,0.1,0,0.2,0,0.4c0,0.2-0.1,0.4-0.2,0.5 c-0.1,0.2-0.2,0.4-0.4,0.5c-0.2,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.1,0 s0.1,0,0.1-0.1c0.1,0,0.2-0.1,0.3-0.2c0.3-0.1,0.6-0.4,0.8-0.6c0.3-0.3,0.5-0.6,0.6-0.8c0.1-0.1,0.1-0.2,0.2-0.3 C181,404.2,181.1,404.2,181.1,404.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_750_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_758_",
    className: "st18",
    d: "M223.5,295.9c2.5-4.2,11.1-6.3,16.1,0L223.5,295.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_757_",
    className: "st31",
    d: "M213.8,291.9c5.5-3.4,16.9-4.7,20.3-3.4c3.4,1.3,6,4.3,4.8,5.2c-1.2,0.9-5-1.5-7.2-0.6 c-6.1,2.5-7.9,5.4-18.5,5L213.8,291.9z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_756_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M215.7,300.5c-5.7,1.4-27,6.6-33.5,7.4c-6.4,0.7-20.4-12-25-16.6c-0.9,2.8-2,5.3-3.7,7.9 c-2.4,3.4-4,11.5-2.9,13.4c1,1.5,3.6,3.7,4,4.9c0.3,1.3-1.8,5.3-11.2,8.1c-11.9-20.4-8-13.7-17.3-29.7 c19.5-28.7,6.3-9.3,21.6-31.8c8.9,0.1,34.2,29.7,36.7,29.3c29.2-5.2,27.7-5.3,28.6-4.3c1,1.1,2.7,3.4,3.6,7.4 C216.9,298.2,217.4,300,215.7,300.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M143.1,325.8l-17.5-30.1l0.1-0.1c10.4-15.3,11.5-16.9,12.6-18.5l9.1-13.4l0.2,0 c5.7,0.1,17.9,11.9,26.8,20.6c4.5,4.3,9.1,8.8,9.9,8.7c6.7-1.2,11.7-2.1,15.6-2.8c12.5-2.3,12.5-2.3,13.1-1.5l0.1,0.1 c0.9,1.1,2.7,3.4,3.6,7.3l0.1,0.3c0.4,1.8,0.9,3.9-1.1,4.4c-6.2,1.5-27.1,6.7-33.5,7.4c-6.8,0.8-21.3-12.8-24.9-16.3 c-0.9,2.8-1.9,5.1-3.6,7.5c-2.4,3.4-3.9,11.3-2.9,13c0.4,0.6,1.1,1.3,1.7,2c1.1,1.1,2.1,2.2,2.3,3c0.4,1.5-1.9,5.7-11.4,8.4 L143.1,325.8z M126.3,295.8l17.1,29.4c9.1-2.7,11.1-6.5,10.8-7.7c-0.2-0.7-1.2-1.8-2.1-2.7c-0.7-0.7-1.3-1.4-1.7-2h-0.1l0-0.2 c-1.1-2.1,0.6-10.3,2.9-13.6c1.7-2.5,2.7-4.9,3.7-7.8l0.1-0.4l0.3,0.3c8.2,8,19.6,17.1,24.8,16.5c6.4-0.7,27.2-5.8,33.5-7.4 c1.3-0.3,1.1-1.6,0.7-3.6c0,0-0.1-0.2-0.1-0.2c-0.9-3.9-2.6-6.3-3.5-7.3c0,0-0.1-0.1-0.1-0.1c-0.4-0.5-0.7-0.5-12.6,1.7 c-3.9,0.7-8.9,1.6-15.6,2.8c-1,0.2-4.1-2.7-10.4-8.8c-8.8-8.5-20.7-20.1-26.3-20.4l-9,13.2C137.7,279,136.6,280.6,126.3,295.8 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_755_",
    className: "st34",
    d: "M216.9,300c0,0-27.4,6.9-34.9,7.7c-5.3,0.6-15.6-7.9-21.2-13c-0.5-0.6-5.6-5.4-6.5-5.1 c-2,0.8-5.5,9-6.5,13.5c-0.8,3.4,0,6.7,2.5,9.3c1,1.5,3.6,3.7,4,4.9c0.3,1.3-1.8,5.3-11.2,8.1c-11.4-19.5-9.5-15.8-11.3-21 c1.1-6.3,3.7-21.5,4.7-27.8c6.5-4.4,2-1.4,13-8.7c3.9,2.4,10.3,14.9,13.9,20.1s14,16,18.5,16.3c3.9,0.2,28.8-6.6,34.5-8.2 C216.6,297.3,216.8,298.6,216.9,300z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_754_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M181,296.9c0,0-0.1,0-0.1,0c-0.1-0.1-0.2-0.2-0.1-0.3c0.4-0.9,1.8-3,2-3.2c0.1-0.1,0.3-0.1,0.4,0 s0.1,0.3,0,0.4c-0.2,0.2-1.5,2.2-1.9,3.1C181.2,296.9,181.1,296.9,181,296.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_753_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M184.2,296.8c-0.1,0-0.2-0.1-0.2-0.2c0,0-0.6-1.8-0.9-2.3c-0.1-0.1,0-0.3,0.1-0.3c0.1-0.1,0.3,0,0.3,0.1 c0.3,0.6,0.9,2.3,0.9,2.4C184.5,296.6,184.4,296.7,184.2,296.8C184.3,296.8,184.2,296.8,184.2,296.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_752_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M157.1,291.5c-0.1,0-0.1,0-0.2-0.1c-0.3-0.4-3.4-3.8-3.7-4.2c-0.1-0.1,0-0.3,0.1-0.3 c0.1-0.1,0.3,0,0.3,0.1c0.2,0.3,2.3,2.6,3.6,4.2c0.1,0.1,0.1,0.3,0,0.4C157.2,291.5,157.2,291.5,157.1,291.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_751_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M151.5,314.7c0,0-0.1,0-0.1,0c-2.4-1.1-6.9-1.8-6.9-1.8c-0.1,0-0.2-0.1-0.2-0.3c0-0.1,0.2-0.2,0.3-0.2 c0.2,0,4.6,0.7,7,1.8c0.1,0.1,0.2,0.2,0.1,0.3C151.7,314.7,151.6,314.7,151.5,314.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_741_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_749_",
    className: "st31",
    d: "M151,231.5c0.7,8.7,7.6,9.3,1.3,11.5c0,0,1,7.8-5.4,9.8l-6.2-11.7l4.4-8.1L151,231.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_748_",
    className: "st35",
    d: "M153,265.4c-1,7.5-8.3,9.2-10.5,18.3c-2.2,9.1,4.4,10,3.6,18.5c-0.7,8.5-9,11.1-9,11.1 c-0.1-0.1-38.8-29-38.8-29.1c0.1,0-1.4-3.5,6.7-7.7c8.1-4.1-5.4-13.2,1.2-21.6c5.8-7.3,10.9,3.2,14.1-18.4 c3.2-21.6,18.3-21.2,23.4-17.5c15,0.7,12.1,11.9,2,23.2C140.1,248.5,154,257.9,153,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_747_",
    className: "st36",
    d: "M153,265.4c-1,7.5-8.3,9.2-10.5,18.3c-2.2,9.1,4.4,10,3.6,18.5c-0.7,8.5-9,11.1-9,11.1 c0,0-0.1,0-0.1,0l-13.4-30.2c-7.2-14.1,8.2-18.4,14.3-28.8c4.2-7.1,1.7-13.9,3.1-18.1c1.4-4.2,7.3-0.3,9.8-7 c1.9-5.2-0.3-8-1.3-8.9c9.3,3.9,2.8,14.3-3.9,21.8C140.1,248.5,154,257.9,153,265.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_746_",
    className: "st36",
    d: "M116.5,284.2l-12.4,4.4c-3.5-2.6-5.8-4.3-5.8-4.4c0.1,0-1.4-3.5,6.7-7.7 c0.1,0,0.1-0.1,0.2-0.1c5.3-0.8,8.4-3.1,6.5-7.8c-4.5-11.5,12.6-10.8,11.9-22c0,0,3.1,8.6-5.6,13.3 C108.4,265.2,125.7,277.3,116.5,284.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_745_",
    className: "st31",
    d: "M148.5,239.9c-1.1-4.7-8-2.2-2.6,6.2L148.5,239.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_744_",
    className: "st37",
    d: "M144.6,244.5c0,0,0,0.2,0,0.4s-0.1,0.7-0.1,1.2c0,0.5,0,1.2,0.1,1.9 c0.1,0.7,0.3,1.6,0.5,2.5c0.2,0.9,0.5,1.9,0.8,2.9c0.3,1,0.6,2.1,0.9,3.2c0.3,1.1,0.5,2.3,0.5,3.6c0,1.2-0.2,2.5-0.8,3.7 c-0.6,1.1-1.4,2.1-2.2,3.1c-0.8,0.9-1.6,1.8-2.4,2.6c-1.6,1.7-3,3.3-4,4.9c-0.5,0.8-0.9,1.5-1.1,2.2c-0.3,0.7-0.4,1.3-0.4,1.9 c0,0.3,0,0.5,0,0.7c0,0.2,0,0.4,0,0.5c0,0.3,0,0.4,0,0.4s0-0.2-0.1-0.4c0-0.1,0-0.3,0-0.5c0-0.2,0-0.5,0-0.7 c0-0.5,0.1-1.2,0.4-1.9c0.2-0.7,0.6-1.5,1-2.3c0.9-1.6,2.3-3.3,3.9-5c0.8-0.9,1.6-1.7,2.4-2.7c0.8-0.9,1.5-1.9,2.1-3 c0.3-0.5,0.5-1.1,0.6-1.7l0.1-0.4l0-0.4c0-0.3,0.1-0.6,0-0.9c0-1.2-0.2-2.4-0.4-3.5c-0.5-2.2-1.1-4.3-1.5-6.2 c-0.2-0.9-0.3-1.8-0.4-2.5c-0.1-0.8-0.1-1.4,0-2c0-0.5,0.1-1,0.2-1.2C144.5,244.7,144.6,244.5,144.6,244.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_743_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M111.4,279.7c-0.1,0-0.2-0.1-0.3-0.2c-1.3-3.9,0.5-6.1,2.3-8.2c1.2-1.4,2.3-2.8,2.5-4.6 c0.3-2.1-0.9-3.8-2.2-5.7c-1.5-2.3-3.3-4.9-3.3-8.7c0-4.4,3.7-7.5,6.7-9.9c1.9-1.6,3.5-2.9,3.5-4.1c0-0.2,0.1-0.3,0.3-0.3 s0.3,0.1,0.3,0.3c0,1.4-1.6,2.8-3.7,4.5c-2.9,2.4-6.5,5.4-6.5,9.5c0,3.7,1.7,6.2,3.2,8.4c1.3,2,2.6,3.8,2.3,6.1 c-0.2,2-1.5,3.4-2.6,4.8c-1.7,2.1-3.4,4.1-2.2,7.7C111.7,279.5,111.6,279.6,111.4,279.7C111.4,279.7,111.4,279.7,111.4,279.7z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_742_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M133.1,298.2c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.3,0-0.4c0,0,2.4-2.8,2-8.8c-0.1-1.9-1.8-3.8-3.5-5.9 c-3.6-4.2-8.1-9.4-1-17.5c9.8-11.3,8.6-15.3,6.9-20.9l-0.2-0.7c0-0.1,0-0.3,0.2-0.4c0.1,0,0.3,0,0.4,0.2l0.2,0.7 c1.7,5.7,3,9.9-7.1,21.4c-6.8,7.8-2.7,12.6,1,16.8c1.8,2.1,3.5,4.1,3.7,6.2c0.4,6.2-2,9.1-2.1,9.2 C133.2,298.2,133.2,298.2,133.1,298.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_512_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_730_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_738_",
    className: "st38",
    d: "M118.3,415.9c0,2.3-1.9,4.2-4.2,4.2c-2.3,0-4.2-1.9-4.2-4.2 C109.9,410.3,118.3,410.3,118.3,415.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_735_",
    className: "st33",
    d: "M152.8,420.2c-5.6,0-5.6-8.4,0-8.4C158.3,411.8,158.3,420.2,152.8,420.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_734_",
    className: "st38",
    d: "M154.2,414.3h-2.5c0-4.7,0.8-10-4.3-10c-7.7,0-6.8-8.4-6.8-10.6h2.5 C143,410.7,154.2,391.6,154.2,414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_733_",
    className: "st38",
    d: "M130.7,420.2c5.6,0,5.6-8.4,0-8.4C125.1,411.8,125.1,420.2,130.7,420.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_732_",
    className: "st38",
    d: "M131.8,414.3h-2.5c0-22.7,11.2-3.5,11.2-20.7h2.5c0,1.5,1.1,10.6-6.8,10.6 c-2.4,0-4.3,1.9-4.3,4.3L131.8,414.3L131.8,414.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_727_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_729_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M184.7,348.6c-14.3,16-44.4,14.4-58,13.4c-13.6-1-18-4.5-22.8-15.5c-4.8-11-10.9-38.4-9.3-53 c2-17.5,19.9-16.6,27.2-12.7c14,7.4,14.5,22.2,24.6,46.5c8.2,19.8,23.2,20.5,33.7,21.1C182.8,348.6,184.7,348.6,184.7,348.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M140.6,362.9c-5.8,0-10.7-0.4-13.8-0.6c-13.3-1-18-4.2-23.1-15.7c-4.9-11.2-11-38.5-9.3-53.1 c0.7-6.2,3.6-10.8,8.2-13.2c6.1-3.2,14.6-2.3,19.4,0.3c10.1,5.3,13.2,14.5,18,28.3c1.8,5.4,3.9,11.5,6.7,18.3 c8.1,19.5,22.6,20.3,33.3,20.9l0.1,0c2.7,0.1,4.6,0.2,4.6,0.2l0.6,0l-0.4,0.5C174.3,360.7,154.8,362.9,140.6,362.9z  M111.7,278.7c-3,0-6.2,0.6-8.8,2c-4.6,2.4-7.2,6.7-7.9,12.8c-1.7,14.6,4.3,41.7,9.2,52.8c4.9,11.2,9.6,14.4,22.6,15.4 c10.5,0.8,42.4,3.2,57.3-12.9c-0.8,0-2.2-0.1-4-0.2l-0.1,0c-10.2-0.6-25.6-1.4-33.8-21.3c-2.8-6.9-4.9-13-6.7-18.4 c-4.7-13.7-7.8-22.8-17.7-28C119.1,279.6,115.5,278.7,111.7,278.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_728_",
    className: "st40",
    d: "M184.7,348.6c-14.3,16-44.4,14.4-58,13.4c-13.6-1-18-4.5-22.8-15.5 c-4.8-11-10.9-38.4-9.3-53c2-17.5,19.9-16.6,27.2-12.7c-1.6,0-3.9,0.6-6.3,2.8c-4.7,4.2,3.5,57,9.4,65s23.2,9.3,32.4,7.7 c7.5-1.3,18.8-6.1,22.7-7.9C182.8,348.6,184.7,348.6,184.7,348.6z"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1231_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1383_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M302.3,315.6c80.3,0,75.8,0.5,76.1-1.1c8.4-42.2,9-41.8,6.6-41.8c-80.3,0-75.8-0.5-76.1,1.1 C300.6,316,300,315.6,302.3,315.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M362.4,316.2c-4.1,0-9.1,0-15.5,0c-10.6,0-25.2,0-44.6,0h-0.1c-0.5,0-1,0-1.3-0.4c-0.8-1-0.3-3.4,3-19.5 c1.2-5.8,2.6-13,4.5-22.5c0-0.1,0-0.1,0-0.2c0-1.1,0.7-1.2,4.5-1.4c3.9-0.1,11.8-0.1,27.5-0.1c10.6,0,25.2,0,44.6,0h0.1 c0.4,0,1,0,1.3,0.4c0.8,1,0.3,3.4-3,19.5c-1.2,5.8-2.6,13-4.5,22.5c0,0.1,0,0.1,0,0.2c0,1.1-0.7,1.2-4.5,1.4 C372.1,316.2,368.4,316.2,362.4,316.2z M302.3,315.1c19.4,0,33.9,0,44.6,0.1c23.4,0,30.1,0.1,31-0.4c0,0,0,0,0,0 c0-0.1,0-0.2,0-0.3c1.9-9.5,3.3-16.7,4.5-22.5c2.6-12.8,3.7-18.1,3.2-18.6c-0.1,0-0.3,0-0.5,0H385c-19.4,0-33.9,0-44.6-0.1 c-23.4,0-30.1-0.1-31,0.4c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c-1.9,9.5-3.3,16.7-4.5,22.5c-2.6,12.8-3.7,18.1-3.2,18.6 C301.8,315.1,302.1,315.1,302.3,315.1L302.3,315.1L302.3,315.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1232_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1382_",
    className: "st41",
    d: "M372.3,287.7c3.8,0,5.5,0.3,5.5-1.3c0-3.8,0.3-5.5-1.3-5.5c-3.8,0-5.5-0.3-5.5,1.3 C371.1,286.1,370.7,287.7,372.3,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1381_",
    className: "st8",
    d: "M335.7,287.7c27,0,27,0.5,27-1.3c0-3.8,0.3-5.5-1.3-5.5c-27,0-27-0.5-27,1.3v4.2 C334.5,287.2,335,287.7,335.7,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1380_",
    className: "st9",
    d: "M314.6,287.7c10.6,0,11.7,0.4,11.7-1.3c0-3.8,0.3-5.5-1.3-5.5c-10.6,0-11.7-0.4-11.7,1.3 C313.3,286.1,312.9,287.7,314.6,287.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1379_",
    className: "st41",
    d: "M370.3,297.1c3.8,0,5.5,0.3,5.5-1.3c0-3.8,0.3-5.5-1.3-5.5c-3.8,0-5.5-0.3-5.5,1.3 C369,295.4,368.7,297.1,370.3,297.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1378_",
    className: "st8",
    d: "M333.7,297.1c27,0,27,0.5,27-1.3c0-3.8,0.3-5.5-1.3-5.5c-27,0-27-0.5-27,1.3 C332.4,295.4,332.1,297.1,333.7,297.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1236_",
    className: "st9",
    d: "M312.5,297.1c10.6,0,11.7,0.4,11.7-1.3c0-3.8,0.3-5.5-1.3-5.5c-10.6,0-11.7-0.4-11.7,1.3 C311.3,295.4,310.9,297.1,312.5,297.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1235_",
    className: "st41",
    d: "M368.6,307.2c3.8,0,5.5,0.3,5.5-1.3c0-3.8,0.3-5.5-1.3-5.5c-3.8,0-5.5-0.3-5.5,1.3 C367.3,305.6,367,307.2,368.6,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1234_",
    className: "st8",
    d: "M332,307.2c27,0,27,0.5,27-1.3c0-3.8,0.3-5.5-1.3-5.5c-27,0-27-0.5-27,1.3 C330.7,305.6,330.4,307.2,332,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1233_",
    className: "st9",
    d: "M310.8,307.2c10.6,0,11.7,0.4,11.7-1.3c0-3.8,0.3-5.5-1.3-5.5c-10.6,0-11.7-0.4-11.7,1.3 C309.6,305.6,309.2,307.2,310.8,307.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectsImage);
export default __webpack_public_path__ + "static/media/projects_image.8dbe5d276fd8fcd8869e1d720f0996e5.svg";
export { ForwardRef as ReactComponent };